/**
 * The new design's one face: Manrope, variable (200–800), self-hosted under
 * public/fonts/manrope/ with its licence (OFL). One file serves every weight —
 * the four "weights" Google Fonts lists are the same variable font.
 *
 * On the first download, so it stays tiny: the door (PavilionHomeDoor.tsx)
 * preloads the face while the page's own chunk is still arriving, so the
 * headline paints in Manrope rather than swapping to it a moment later.
 */
export const PAVILION_FONT_URL = '/fonts/manrope/manrope-latin-variable.woff2';

/** Ask for the face early. Idempotent; a browser that cannot preload simply loads it with the stylesheet. */
export function preloadPavilionFont(doc: Document = document): void {
  try {
    if (doc.head.querySelector('link[data-pv-font]')) return;
    const link = doc.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.href = PAVILION_FONT_URL;
    link.crossOrigin = 'anonymous';
    link.setAttribute('data-pv-font', '');
    doc.head.appendChild(link);
  } catch {
    /* no document head (tests): the stylesheet still names the face */
  }
}
